import React from 'react';
import { DocumentsBlock } from '@coog/react-components';
import PropTypes from 'prop-types';

const DocumentsPresentational = ({ blockDocuments, strings }) => {
  // DocumentsBlock

  return (
    <>
      <DocumentsBlock data={blockDocuments} stringsProp={strings} />
    </>
  );
};

DocumentsPresentational.propTypes = {
  blockDocuments: PropTypes.object.isRequired, // eslint-disable-line
  strings: PropTypes.objectOf(PropTypes.string),
};

DocumentsPresentational.defaultProps = {
  isFinishedSalesRoute: false,
  strings: {},
};

export default DocumentsPresentational;
